import { AGREEMENT_SECTIONS } from "../data/membership";

export default function MembershipAgreement() {
  return (
    <main data-testid="membership-agreement-page" className="pt-20 md:pt-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white mb-2">
          Membership Agreement
        </h1>
        <p className="text-zinc-500 text-sm mb-10">Mason's Mobile Membership — $39.99/month</p>
        <div className="space-y-8">
          {AGREEMENT_SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-heading text-lg font-semibold text-white mb-2">{s.title}</h2>
              <p className="text-zinc-400 text-sm leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
